import { PORTAL_BASE_URL } from "@graffer-inc/smart-apply/dist/utils/url";
import { Dispatch, SetStateAction } from "react";
import { TextField } from "@graffer-inc/console-design-kit";
import { CustomPathSettings } from "../../../../../application/domain/procedures/custom-path";
import { validateCurrentCustomPathFormat } from "./custom-path-validator";
import { formatDatetime } from "../../../../../utils/date-utils";
import { OptionalTag } from "../../../../atoms/optional-tag";

type ProcedureCustomPathSettingProps = {
  orgSlug: string;
  currentURL: string;
  existingCustomPathSettings: CustomPathSettings;
  newCurrentCustomPath: string;
  setNewCurrentCustomPath: Dispatch<SetStateAction<string>>;
};

export const ProcedureCustomPathSetting: React.FC<
  ProcedureCustomPathSettingProps
> = ({
  orgSlug,
  currentURL,
  existingCustomPathSettings,
  newCurrentCustomPath,
  setNewCurrentCustomPath,
}) => {
  return (
    <>
      <div className="mb-4">
        <div className="columns mx-0 mt-0 mb-3">
          <div className="column is-narrow p-0">
            <label htmlFor="custom-path-text-input" className="label">
              申請開始ページURL
            </label>
          </div>
          <div className="column is-narrow p-0">
            <OptionalTag />
          </div>
        </div>
        <div className="my-0" style={{ lineHeight: 1.5, fontSize: "14px" }}>
          <p>
            現在のURL :<b className="ml-2">{currentURL}</b>
          </p>
          <p>
            URLの末尾を、任意の文字列に変更できます。紙や外部メディアにURLや二次元コードを掲載する場合は、申請開始ページURLを設定してください。
          </p>
          {existingCustomPathSettings.reserved?.path &&
            existingCustomPathSettings.reserved?.startDatetime && (
              <p>
                ※
                <b className="ml-1">
                  {formatDatetime(
                    existingCustomPathSettings.reserved.startDatetime,
                  )}
                </b>
                以降に、変更予約された
                <b>「{existingCustomPathSettings.reserved.path}」</b>
                へ変更されます。
              </p>
            )}
        </div>
        <div className="columns m-1 pt-1">
          {/* TextFieldにエラーメッセージが表示された時に、縦幅が変わるので、align itemsは利用せずにmarginで調整する */}
          <div className="column is-narrow p-0 mt-2">
            <span className="has-text-grey">
              {PORTAL_BASE_URL!}/{orgSlug}
              /smart-apply/apply-procedure-alias/
            </span>
          </div>
          <div className="column p-0 ml-1">
            <TextField
              label={""}
              description={""}
              placeholder={"move-out"}
              id="custom-path-text-input"
              onChange={(e) => {
                setNewCurrentCustomPath(e.target.value);
              }}
              errorMessages={validateCurrentCustomPathFormat(
                newCurrentCustomPath,
                !!existingCustomPathSettings.currentPath,
              )}
              value={newCurrentCustomPath}
              shouldDisplayError={true}
            />
          </div>
        </div>
      </div>
    </>
  );
};
